/**
 * Exemplo de nome de setor pré-preenchido no estado vazio, conforme o segmento
 * do tenant. Ajuda o usuário a criar o primeiro setor com um rótulo familiar ao
 * seu tipo de negócio. Fallback genérico "Atendimento" para segmento
 * indefinido/desconhecido.
 *
 * Segmentos canônicos vêm de `tenant.segment` (mesmos valores usados no
 * settings.js do negócio): barbearias, consultorios, mecanicas, lava_jatos,
 * academias.
 */
export const SEGMENT_DEPARTMENT_EXAMPLE = {
  barbearias: "Atendimento",
  consultorios: "Recepção",
  mecanicas: "Orçamentos",
  lava_jatos: "Atendimento",
  academias: "Atendimento",
};

export const DEFAULT_DEPARTMENT_EXAMPLE = "Atendimento";

/**
 * @param {string|null|undefined} segment  tenant.segment
 * @returns {string} nome de setor de exemplo para o segmento (ou fallback)
 */
export function exampleDepartmentName(segment) {
  return SEGMENT_DEPARTMENT_EXAMPLE[segment] || DEFAULT_DEPARTMENT_EXAMPLE;
}
